import { IOHelper } from '../../IOHelper';
import { createSerializeWire } from '../Serializable';
const SIZE = IOHelper.sizeOfUInt256 + IOHelper.sizeOfFixed8 + IOHelper.sizeOfUInt160;
export class OutputModel {
    constructor({ asset, value, address }) {
        this.size = SIZE;
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.asset = asset;
        this.value = value;
        this.address = address;
    }
    clone({ value = this.value }) {
        return new OutputModel({
            asset: this.asset,
            value,
            address: this.address,
        });
    }
    serializeWireBase(writer) {
        writer.writeUInt256(this.asset);
        writer.writeFixed8(this.value);
        writer.writeUInt160(this.address);
    }
}
OutputModel.size = SIZE;

//# sourceMappingURL=OutputModel.js.map
